module.exports = __webpack_public_path__ + "static/media/fold-folded.de3577e4.png";